import { v3, type Vec3 } from '../math.ts';
import type { ClassId, Faction } from '../constants.ts';

export interface TestCombatant {
  name: string;
  faction: Faction;
  cls: ClassId;
  pos: Vec3;
  /** Fires back, which is the only way to reach the ghost path solo. */
  attacks?: boolean;
  /** Fixed level. Test combatants never gain experience, so this is where they stay. */
  level?: number;
  why: string;
}

/**
 * Test combatants for the solo Cathedral. Kept in core rather than in `main.ts`
 * so a test can assert the thing that actually went wrong the first time: a
 * dummy parked inside a pool's capture radius contests it permanently, which
 * freezes that pool for the whole match and reads as a broken capture system.
 */
export const CATHEDRAL_TEST_ROSTER: readonly TestCombatant[] = [
  {
    name: 'Target', faction: 'chaos', cls: 'magician', pos: v3(0, 0.6, -8),
    why: 'Standing in the nave with clear line of sight through the north opening. Shoot this one first.',
  },
  {
    name: 'Sniper', faction: 'chaos', cls: 'mentalist', pos: v3(32, 0.6, 20), attacks: true, level: 3,
    why: 'Guards the Chaos shrine alongside the Defender. Far enough from the Order spawn that you are '
      + 'never shot before you can move, so dying is a place you walk into rather than something that '
      + 'happens to you. Pinned at level 3 — a dummy that fires continuously earns experience '
      + 'continuously, and an unattended one reaches level 25 in three minutes and becomes unkillable.',
  },
  {
    name: 'Defender', faction: 'chaos', cls: 'cleric', pos: v3(26, 0.6, 26),
    why: 'Parked on the Chaos shrine. Contests any conquest attempt until it is killed.',
  },
  {
    name: 'Ally', faction: 'order', cls: 'cleric', pos: v3(-3, 0.6, -26),
    why: 'Friendly Cleric. Proves friendly fire does nothing, and can raise you.',
  },
];
